import styles from "./EscalatedIncidentItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
/**
 *
 * Displays the information of an incident in the escalated incident section. Clicking on the incident number will take the user to the incident details page.
 *
 */

export function EscalatedIncidentItem({
  index,
  IncidentDetails,
  onSuspendClick,
}) {
  const shortNumber = IncidentDetails.id.substring(0, 8) + "...";
  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
    >
      {/* This link breaks in storybook */}
      <Link to={`/security/incident/${IncidentDetails.id}`}>
        <div className={classNames(styles.gridItem, styles.link)}>
          {shortNumber}
        </div>
      </Link>
      <div className={styles.gridItem}>{IncidentDetails.escalation.reason}</div>
      <div className={styles.gridItem}>{IncidentDetails.caseOwner}</div>
      <div className={styles.gridItem}>
        {IncidentDetails.escalation.actionsNeeded}
      </div>
      <div className={(styles.gridItem, styles.buttonDiv)}>
        <button className={styles.button} onClick={onSuspendClick}>
          View
        </button>
      </div>
    </div>
  );
}

EscalatedIncidentItem.propTypes = {
  index: PropTypes.number,
  IncidentDetails: PropTypes.object,
  onClick: PropTypes.func,
  onViewClick: PropTypes.func,
};
